import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/responsive.css'
import './styles/mobile.css'
import './styles/tool-page.css'
import './styles/user-account-panel.css'
import './styles/mzz-media.css'

Vue.config.productionTip = false
Vue.config.devtools = false

Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

